import type { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

export const DELAYED_TOAST_CONSTANTS = {
    Z_INDEX: 1000,
    HEIGHT: 55,
    DEFAULT_HORIZONTAL_MARGIN: 15,
    POSITION: "absolute",
    BOTTOM_BAR_HEIGHT: 90,
    BOTTOM_BAR_HEIGHT_WITH_CART: 150,
    TOAST_BOTTOM_MARGIN: 12,
    TOAST_DEFAULT_SIZE: 60,
    BOTTOM_STICKY_ELEMENT_ID: "cta-list-container",
    DELAY_ACTION_DURATION: 3000, // 3 seconds
    BUTTON_TEXT: "View",
    PROGRESS_COLOR: "background_inverse_Primary" as keyof IColors,
    // FAB Widget wait constants
    FAB_WIDGET_MAX_WAIT_TIME: 2000,
    FAB_WIDGET_ANIMATION_DURATION: 1500,
    FAB_WIDGET_FALLBACK_TIMEOUT: 3500,
};

export const DELAYED_TOAST_BUTTON_TYPES = {
    SCREEN: "SCREEN",
    CANCEL: "CANCEL",
};

export const DELAYED_TOAST_IDS = {
    BUTTON_ID: "fab-widget-button",
    CONTAINER_ID: "fab-widget-container",
};
